import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { BraConfirmComponent } from '../componentes/bra-confirm/bra-confirm.component';
import { SegundaViaModalDebitoAutomaticoComponent } from './segundavia-modal-debito-automatico.component';
import { SessaoService } from '../services/sessao.service';
import { SegundaViaService } from '../services/segundavia.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { Contrato } from '../modelo/contrato';
import { Parcela } from '../modelo/parcela';
import { DebitoAutomaticoContratoDetalhe } from '../modelo/debito-automatico-contrato-detalhe';
import { Config } from '../services/config';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DebitoAutomaticoService } from '../services/debitoautomatico.service';
import { BraAlertLiquidacaoComponent } from '../componentes/bra-alert-liquidacao/bra-alert-liquidacao.component';

declare var $: any;

@Component({
  selector: 'app-segundavia-modal-boleto',
  templateUrl: './segundavia-modal-boleto.component.html',
  styleUrls: ['./segundavia.component.css'],
  providers: [SegundaViaService, MensagemService, RestClientService, DebitoAutomaticoService]
})
export class SegundaViaModalBoletoComponent extends AbstractComponent implements OnInit {

  parcela: Parcela;
  contrato: Contrato;

  constructor(
    private sessaoService: SessaoService,
    private segundaViaService: SegundaViaService,
    private mensagemService: MensagemService,
    private spinnerService: Ng4LoadingSpinnerService,
    private debitoAutomaticoService: DebitoAutomaticoService,
    private router: Router,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<SegundaViaModalBoletoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(sessaoService);
  }

  ngOnInit() {
    setTimeout(function () {
      $('.modal-boleto-bottom').closest('.cdk-global-overlay-wrapper').css({ 'align-items': "flex-end" });
    }, 0);
    this.parcela = this.data.parcela;
    this.contrato = this.data.contrato;
    this.validarDebitoAutomatico();
  }

  /**
   * Valida a regra de débito automático: somente quando a modalidade for
   * "DEBITO EM CONTA" consulta o contrato e, se o optinVencida for "S",
   * exibe o modal de aviso sobreposto ao de boleto.
   */
  validarDebitoAutomatico() {
    const modalidadeDebitoEmConta = this.contrato.nmModalidade
      && this.contrato.nmModalidade.toUpperCase().includes("DEBITO EM CONTA");

    if (!modalidadeDebitoEmConta) {
      return;
    }

    this.debitoAutomaticoService.consultarContratoDebitoAutomatico(this.contrato).subscribe(
      (result: DebitoAutomaticoContratoDetalhe) => {
        this.spinnerService.hide();
        if (result && result.optinVencida === "S") {
          this.dialog.open(SegundaViaModalDebitoAutomaticoComponent, {
            panelClass: 'modal-debito-automatico'
          });
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

   download() {
    $('.progress').show();
    this.segundaViaService.recuperarDadosBolepix(this.contrato, this.parcela).subscribe(
      result => {
        this.processarDownloadBoleto(result);
      },
      (error: any) => {
        this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
            mensagem: "Houve um erro ao recuperar o boleto. Por favor, tente novamente mais tarde."
          }
        });
        this.hideLoading();
      },
      () => {
        this.hideLoading();
      }
    );
  }

  hideLoading() {
    this.spinnerService.hide();
    $('.progress').hide();
  }

  private processarDownloadBoleto(result: any): void {

    if (result.cdMsgemRetorno != "00" && result.cdMsgemRetorno != "0"){
        this.dialog.open(BraAlertComponent, {
          width: Config.POPUP_50VW,
          data: {
          mensagem: result.dsMsgemRetorno + " (" + result.cdMsgemRetorno + ")"
        }
      });
      return;
    }
    const fileName = "boleto.pdf";
    let data : string;

    if (result.arquivoPdf) {
      data = result.arquivoPdf;
    } else if (result.dsBaseCaracter) {
      data = result.dsBaseCaracter;
    } else {
      console.error('Nenhuma base Base64 foi retornada');
      return;
    }

    const byteCharacters = atob(data.replace(/\s/g, ''));
    const len = byteCharacters.length;
    const uint8Array = new Uint8Array(new ArrayBuffer(len));

    for (let i = 0; i < len; i++) {
      uint8Array[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([uint8Array], { type: 'application/pdf' });

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.download = fileName;
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    if (result.cardif == "S") {
      this.dialog.open(BraAlertLiquidacaoComponent, {
        width: Config.POPUP_50VW,
        data: {
          mensagem: result.dsMsgemRetorno + " (" + result.cdMsgemRetorno + ")"
        }
      });
    }
  }

  /**
   * Monta as popups de confirmação
   * @param result
   */
  montaPopups(result: any) {
    let dialogRef = this.dialog.open(BraConfirmComponent, {
      width: Config.POPUP_50VW,
      data: {
        mensagem: result.dsMsgemRetorno
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Clicou em Sim
        this.recuperarDadosBoletoNaoRegistrado();
      }
      else {
        // Clicou em Não
        this.dialog.open(BraAlertComponent, {
          width: Config.POPUP_50VW,
          data: {
            mensagem: this.getMensagem("ACESSE_MAIS_TARDE")
          }
        });
      }
    });
  }

  /**
   * Busca o PDF do boleto para download
   */
  recuperarDadosBoletoNaoRegistrado() {
    $('.progress').show();
    this.segundaViaService.recuperarDadosBoletoNaoRegistrado(this.contrato, this.parcela).subscribe(
      result => {
        this.processarDownloadBoleto(result);
      },
      (error: Response) => {
        this.dialog.open(BraAlertComponent, {
          width: Config.POPUP_50VW,
          data: {
            mensagem: this.getMensagem("ERRO_CHAMADA_SERVICO")
          }
        });
      },
      () => {
        this.spinnerService.hide();
        $('.progress').hide();
      });
  }

  /**
   * Fecha a modal
   */
  fechar() {
    this.dialogRef.close();
  }

}




// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-segundavia-cli/segundavia-modal-boleto.component.ts